import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { linkscurl } from '../../../apis/urls'
import { decode } from "html-entities";


const EditLinks = () => {

    const { id } = useParams();

    useEffect(() => {
        editlinks();
    },[]
    );

    const [res,setRes] = useState([]);
    const [link_text,setLink_text] = useState('');
    const [link_url, setLink_url] = useState('');
    // const [link_urls, setLink_urls] = useState(null);
    const [link_target, setLink_target] = useState('');
    const [status, setStatus] = useState('');

    const [linktexter,setLinktexter] = useState(false);
    const [linkurler,setLinkurler] = useState(false);
    const [linktargeter,setLinktargeter] = useState(false);

    let navigate = useNavigate();
    const RoutToList = () =>{
        let path = 'newPath'; 
        navigate("/links")     
    }

    console.log("linksss", link_url)

    const editlinks = () => {

        let token = "Bearer "+localStorage.getItem('token');
        const instance   = axios.create({
            baseURL: linkscurl+id,
            timeout: 1000000,
            headers: {'authorization': token}
            });
            
            instance.get('').then((response) =>{
            
            setRes(decode(response.data.data));
            //console.log(response.data.data.link_text)
            //console.log("link_text",res.link_text)
            setLink_url(decode(response.data.data.link_url))
            setLink_text(decode(response.data.data.link_text));
            setLink_target(response.data.data.link_target);
            setStatus(response.data.data.status);
            console.log("link", response.data.data.link_url)


            }).catch((error) =>{
            console.log('error',error.message)
            

            });
    }
    


    const onEditForm = () => {

        let error = 0;

        if(link_text === '')
        {
            setLinktexter(true)
            error = 1;
        }
        if(link_url === '')
        {
            setLinkurler(true)
            error = 1;
        }
        // if(link_target === '')
        // {
        //     setLinktargeter(true)
        //     error = 1;
        // }

        if(error === 0)
        {


            let token = "Bearer "+localStorage.getItem('token');
            
            const data = {
                link_text :link_text,
                link_url :link_url,
                link_target: link_target,
                status :status
            }
            
            const instance = axios.create({

                baseURL: linkscurl+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                
                
                navigate("/links")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }



    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Links</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>


                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/links    ">Links</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit Links</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div class="card formcard small">
                            <div class="card-body">
                                <div class="form-group">
                                    <label className="degreehead">Link Title <span style={{color: "red"}}>*</span></label>
                                    <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setLink_text(e.target.value)}} defaultValue={decode(res.link_text)} id="link_text"></input>
                                    {
                                        linktexter
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Link Text</div>
                                        :null
                                    }
                                
                                </div>
                                <div class="form-group">
                                    <label className="degreehead">Link URL <span style={{color: "red"}}>*</span></label>  
                                    <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setLink_url(e.target.value)}}  defaultValue={decode(res.link_url)} id="desc"></input>
                                    {/* <RteComponents setdescription={setLink_url}   link_url={link_url} /> */}
     
                                    {/* <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setLink_url(e.target.value)}}  defaultValue={link_urls} id="desc"></input> */}

                                    {
                                        linkurler
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The URL</div>
                                        :null
                                    }
                                </div>
                                {/* <div class="form-group">
                                    <label className="degreehead">Link Target <span style={{color: "red"}}>*</span></label>
                                        <select  onChange={e => {setLink_target(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                            <option>Select Status</option>
                                            <option selected="selected">_blank</option>
                                            <option>_self</option>
                                            <option>_parent</option>
                                            <option>_top</option>
                                        </select>

                                        {
                                        linktargeter
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select the Target</div>
                                        :null
                                    }

                                        
                                </div> */}
                                <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                <div class="form-group text-right">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </form>



               


                </div>
            </aside>
        </div>

    )
}

export default EditLinks;

